angular
    .module("app")
    .controller("LocationSearchController", function ($timeout, $scope, $rootScope) {
        var vm = this;
        vm.$onInit = function () {
            $timeout(function () {
                vm.ngModel.$setValidity('required', true);
                vm.autocomplete = new google.maps.places.Autocomplete(
                    vm.element[0],
                    vm.options
                );
                vm.autocomplete.setFields([
                    "address_components",
                    "geometry",
                    "icon",
                    "name"
                ]);
                vm.element.bind('keydown', function () {
                    $scope.$apply(function (s) {
                        s.vm.placeSelected = false;
                    });
                });
                google.maps.event.addListener(vm.autocomplete, 'place_changed', function () {
                    $scope.$apply(function (s) {
                        s.vm.placeSelected = true;
                    });
                    var place = this.getPlace();
                    vm.ngModel.$setViewValue(vm.element[0].value);
                    vm.ngModel.$render();
                    var data = {};
                    data.place = place;
                    place.address_components.forEach(function(elem) {
                        elem.types.forEach(function(item) {
                        if(item === "locality" || item === 'postal_town'
                )
                    {
                        data.city = elem.long_name;
                    }
                else
                    if (item === "country") {
                        data.country = elem.long_name;
                    }
                    else if (item === "postal_code") {
                        data.postal_code = elem.long_name;
                    }
                })
                })
                    ;
                    $rootScope.$broadcast('$place_selected', data);
                });
                $scope.$watch(
                    function () {
                        return vm.options;
                    },
                    function () {
                        vm.autocomplete.setComponentRestrictions(
                            vm.options.componentRestrictions
                        );
                    },
                    true
                );
            }, 0);
        };
    });
